<template>
  <div>
    <div class="step-progress-container">
      <h4 :style="{ paddingLeft: '12px', marginBottom: '0', fontWeight: '600' }" v-translate>
        Here's what's next:
      </h4>
      <!-- delete later -->
      <div class="step" :class="{ 'active-step': step1 === true }">
        <div>
          <div class="circle" :style="organizationCssVars">
            <font-awesome-icon
              :icon="['fa', 'check']"
              class="bullet"
              :style="{ color: 'white', fontSize: '.9em', fontWeight: '300' }"
            />
          </div>
        </div>
        <div>
          <h5 class="title" v-translate>Step 1: Verify eligibility</h5>
        </div>
      </div>
      <div class="step" :class="{ 'active-step': step2 === true }">
        <div>
          <div class="circle" :style="organizationCssVars">
            <font-awesome-icon
              :icon="['fa', 'check']"
              class="bullet"
              :style="{ color: 'white', fontSize: '.9em', fontWeight: '300' }"
            />
          </div>
        </div>
        <div>
          <h5 class="title" v-translate>Step 2: Personal information</h5>
        </div>
      </div>
      <div v-if="organizationDetails.isFinancialHealthSurveyEnabled" class="step" :class="{ 'active-step': step3 === true }">
        <div>
          <div class="circle" :style="organizationCssVars">
            <font-awesome-icon
              :icon="['fa', 'check']"
              class="bullet"
              :style="{ color: 'white', fontSize: '.9em', fontWeight: '300' }"
            />
          </div>
        </div>
        <div :style="{ width: '275px' }">
          <h5 class="title" v-translate>Step 3: Financial health survey</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'StepProgressBar',
  props: {
    step1: {
      type: Boolean,
    },
    step2: {
      type: Boolean,
    },
    step3: {
      type: Boolean,
    },
  },
  computed: mapState(['organizationDetails', 'organizationCssVars']),
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.hidden {
  display: none;
}
// this styling is horrible
.step-progress-container {
  border-radius: 9px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  margin: 30px 0;
  padding: 20px 5px;
  display: flex;
  flex-direction: column;
}

// delete later

.step {
  position: relative;
  min-height: 1em;
  color: var(--dark-brand-color);
  margin-top: 1rem;
}
.step > div:first-child {
  position: static;
  height: 0;
}
.step > div:not(:first-child) {
  margin-left: 1.5em;
  padding-left: 1em;
}
.step.active-step {
  color: var(--dark-brand-color);
}
.step.active-step .circle {
  background-color: var(--dark-brand-color);
}

/* Step Circle */
.circle {
  background: $white;
  position: relative;
  width: 1.6em;
  height: 1.6em;
  line-height: 1.5em;
  border-radius: 100%;
  border: 2.4px solid var(--dark-brand-color);
  color: $white;
  text-align: center;
  box-shadow: 0 0 0 3px $white;
}

/* Vertical Line */
.circle:after {
  content: ' ';
  position: absolute;
  display: block;
  top: 1px;
  bottom: 1px;
  left: 44%;
  height: 100%;
  width: 0.15rem;
  transform: scale(1, 2);
  transform-origin: 50% -100%;
  background-color: var(--dark-brand-color);
  z-index: -1;
}
.step:last-child .circle:after {
  display: none;
}

/* Stepper Titles */
.title {
  line-height: 1.5em;
  font-weight: bold;
}
</style>
